import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
const root = (ReactDOM as any).createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
